import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import Collapse from "../../UI/Collapse/Collapse";
import Loading from "../../UI/Loading/Loading";
const SidebarListItem = ({ color, children, text, iconStatus, onToggle, isLoading, }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    let statusIcon = "";
    if (iconStatus === "success") {
        statusIcon = "fa-check-circle text-success";
    }
    else if (iconStatus === "fail") {
        statusIcon = "fa-times-circle text-danger";
    }
    else if (iconStatus === "question") {
        statusIcon = "fa-question-circle text-muted";
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "list-group-item list-group-item-action clickable d-flex justify-content-between align-items-center", onClick: () => {
                    if (onToggle) {
                        onToggle(!isOpen);
                    }
                    setIsOpen((o) => !o);
                }, children: [_jsx("div", { className: "pl-2", style: {
                            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'BorderLeft<string | number> | undefined'.
                            borderLeft: color && `2px solid ${color}`,
                        }, children: text }), _jsxs("div", { className: "d-flex flex-nowrap flex-grow-1 ml-3 justify-content-end h-100 align-items-center", children: [_jsx("span", { className: `fal fa-fw ${statusIcon} mr-2`, "aria-hidden": true }), isLoading ? (_jsx(Loading, {})) : (_jsx("span", { className: "fal " + (isOpen ? "fa-chevron-up" : "fa-chevron-down"), "aria-hidden": true }))] })] }), _jsx(Collapse, { open: isOpen && !isLoading, children: children })] }));
};
export default SidebarListItem;
